import {Typography, Avatar, ListItem, ListItemAvatar, ListItemText} from '@mui/material';
import Stack from '@mui/material/Stack';
import CommentIcon from '@mui/icons-material/Comment';

export const CommentItem = ({comment}) => {

  return (
        <ListItem
            key={comment.id}
            disableGutters
        >
            <ListItemAvatar >
                <Avatar alt="Project" src={comment?.userimage}>
                    <CommentIcon color="primary" />
                </Avatar>
            </ListItemAvatar>
            <ListItemText  primary={<Stack direction="row" spacing={1} sx={{marginBottom: 0.5}}>
                <Typography>{comment?.comment?.slice(0,300)}</Typography>
                {/* {props.project.ispublic === true && <Chip label="Public" color="primary" size="small" variant="outlined"/>}
                {props.project.ispublic === false && <Chip label="Private" color="primary" size="small" variant="outlined"/>}
                {props.project.allowcomments === true && <Chip label="Comments Enabled" color="primary" size="small" variant="outlined"/>} */}
            </Stack>} secondary={comment?.name + ", " + new Date(comment?.createdon).toLocaleString()} sx={{ paddingRight: 5 }}> </ListItemText>
        </ListItem>
    );
};